import angular from 'angular';
import { Lang } from 'Roblox';

const assetsExplorerConfig = (
  $stateProvider,
  $urlRouterProvider,
  $locationProvider,
  languageResourceProvider
) => {
  languageResourceProvider.setLanguageKeysFromFile(Lang['Feature.Inventory']);
  languageResourceProvider.setLanguageKeysFromFile(Lang['Common.AssetTypes']);
  languageResourceProvider.setLanguageKeysFromFile(Lang['CommonUI.Controls']);

  // validate url
  const loc = window.location.href;
  if (loc.indexOf('#') !== -1 && loc.indexOf('#!') === -1) {
    window.location.href = loc.replace('#', '#!');
  }
  // false mean hashbang mode
  $locationProvider.html5Mode(false);
  $locationProvider.hashPrefix('!');

  $urlRouterProvider.otherwise('/accessories');

  $stateProvider.state('category', {
    url: '/{categoryName}'
  });

  $stateProvider.state('subcategory', {
    url: '/{categoryName}/{subcategoryName}'
  });
};

const assetsExplorer = angular
  .module('assetsExplorer', [
    'robloxApp',
    'assetsExplorerAppTemplates',
    'ui.bootstrap',
    'thumbnails',
    'cursorPagination',
    'ui.router',
    'cursorPagination',
    'verticalMenu'
  ])
  .config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    'languageResourceProvider',
    assetsExplorerConfig
  ]);

export default assetsExplorer;
